export const customScrollTo = (element, options = {}) => {
  const modal = document.getElementById('modal');

  if (modal) {
    modal.scrollTo(0, element.offsetTop);
  } else {
    element.scrollIntoView({ block: 'center', ...options });
  }
};
